import cebiaLogoFooter from '@/images/cebia-logo-blue.svg'
import drivaliaLogoFooter from '@/images/clients/drivalia-logo.png'
import unicreditLogoFooter from '@/images/clients/unicredit-leasing-logo.svg'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

const hosts = [
  'broker-new.cebia.cz'
  , 'broker.cebia.cz'
  , 'localhost:44470'
]

export const CommonClient: IPartnerSettings = {
  partner: 'Cebia',
  hosts: hosts,
  logo: cebiaLogoFooter,
  market: Market.CZ
}

export const UniCreditLeasing: IPartnerSettings = {
  partner: 'UniCreditLeasing',
  deployment: 'UniCreditLeasing',
  hosts: hosts,
  logo: unicreditLogoFooter,
  market: Market.CZ
}

export const LeasePlan: IPartnerSettings = {
  partner: 'LeasePlan',
  hosts: [
    'fip.drivalia.cz'
    // , 'localhost:44470'
  ],
  logo: drivaliaLogoFooter,
  market: Market.CZ
}

export const LeasingCS: IPartnerSettings = {
  partner: 'LeasingCS',
  deployment: 'LeasingCS',
  hosts: hosts,
  market: Market.CZ
}

export const UCLSK: IPartnerSettings = {
  partner: 'UCLSK',
  hosts: hosts,
  logo: unicreditLogoFooter,
  market: Market.SK
}

export const MBFSSK: IPartnerSettings = {
  partner: 'MBFSSK',
  hosts: hosts,
  market: Market.SK
}